<template>
    <v-list-item  v-bind="$attrs" :value="address" v-if="address" @click="selectMe">
          <v-list-item-icon class="mr-3" v-if="!hideIcon"
            ><v-icon color="primary" v-if="selected">check</v-icon>
            <v-icon v-else>home</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="name"></v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
              <v-btn color="success" v-if="isValid" depressed small @click.stop="selectMe">Selecteren</v-btn>
              <v-chip v-if="!isValid" label @click.stop="setNumber" small color="primary">Huisnummer</v-chip>
            </v-list-item-action>
        </v-list-item>
</template>
<script>
export default {
  props: ['value','selected', 'hideIcon'],
  data: () => ({
    address: {},
    showNumber: false,
    number: null
  }),

  computed: {
      isValid(){
         if (!this.address) return false
          if (!this.address.name) return false
          if (!this.address.zipcode) return false
          if (!this.address.number) return false
          if (!this.address.coordinate) return false
          return true
      },
      allowSelect(){
          if (!this.address) return false
          if (!this.address.name) return false
          if (!this.address.zipcode) return false
          if (!this.address.coordinate) return false
          return true
      },
      name (){
        if (!this.address) return null
        return [this.address.street,this.address.number ,this.address.addition,",",this.address.city].filter(a=>a!=undefined).join(' ').replace(' , ',', ')
      }
  },
  mounted(){
      this.address = this.value
  },
  watch: {
    value(value){
        this.address = value
    },
    address(value){
        this.$emit('input',value)
    },
    number(value){
        //this.address = Object.assign(this.address, {number: value, name: this.name})
    },
    showNumber(value){

        if (value) this.number = this.address.number
    }
  },
  methods: {
    selectMe(){
      if (!this.isValid) return this.setNumber()
      this.address.name = this.name
      this.$emit('valid', this.address)
    },
    setNumber(){
      this.address.name = this.name
      this.$emit('select', this.address)
    }
  },
};
</script>